import { jsx as _jsx } from "react/jsx-runtime";
const LargeButton = (props) => {
    return (_jsx("div", { ...props, className: `z-1 flex-1 cursor-pointer rounded-lg border border-slate-300 bg-white p-12 text-lg font-medium hover:border-slate-400 hover:bg-slate-200 ${props.className || ''}`, children: _jsx("span", { className: "pointer-events-none z-0 flex flex-col items-center justify-center gap-2 text-slate-500", children: props.children }) }));
};
export default LargeButton;
